import { render, staticRenderFns } from "./photo-upload.vue?vue&type=template&id=bbaea136&scoped=true&"
import script from "./photo-upload.vue?vue&type=script&lang=js&"
export * from "./photo-upload.vue?vue&type=script&lang=js&"
import style0 from "./photo-upload.vue?vue&type=style&index=0&id=bbaea136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaea136",
  null
  
)

export default component.exports